// extracted by mini-css-extract-plugin
module.exports = {"socialPostImg":"Inbox_socialPostImg__36U0L","textareaField":"Inbox_textareaField__1PQ07","emailTextareaField":"Inbox_emailTextareaField__1Ca87"};